import { 
  EXTERNAL_PASSPORT_APP_DOMAIN_NAME 
} from '../constants/externalSiteConstants';

const isSiteExternal = () => {
  const url = window.location.href;
  return url.includes(EXTERNAL_PASSPORT_APP_DOMAIN_NAME);
};

export default isSiteExternal;